import type { Values } from '../types'

// TODO(minor): convert scripts/sandbox-server to TS, import this wire protocol there so
// clients/server agree.

export const SandboxMessageType = {
  /** client claims the single host slot */
  RegisterHost: 'register-host',
  /** server grants host slot and carries the server's LAN address */
  RegisteredHost: 'registered-host',
  /** server signals to the client that the host slot is already taken */
  ErrorRegisterHost: 'error-register-host',
  /** host delivers schema+entity payload to the clients via the server */
  LatestValue: 'latest-value',
  /** client pushes entith updates to the server and in turn the host */
  UpdateEntityContent: 'update-entity-content',
} as const

export type SandboxMessageType = Values<typeof SandboxMessageType>

export interface SandboxMessage {
  type: SandboxMessageType
  value?: any
}

/** the schema + entity JSON exchanged between host and clients */
export interface SandboxPayload {
  entity: any
  schema: any
}
